import { GridValueFormatterParams } from '@mui/x-data-grid';
import dayjs from 'dayjs';

export default (params: GridValueFormatterParams) => (params.value ? dayjs(params.value).format('DD.MM.YYYY') : '');
